module.exports = __webpack_public_path__ + "static/media/image_80.5facc069.png";